
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","stroke":"#202A21","stroke-width":"1.25","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.666 10.733V9.267c0-.867.708-1.584 1.583-1.584 1.509 0 2.125-1.066 1.367-2.375a1.583 1.583 0 01.583-2.158l1.442-.825c.658-.392 1.508-.158 1.9.5l.092.158c.75 1.309 1.983 1.309 2.741 0l.092-.158c.392-.658 1.242-.892 1.9-.5l1.442.825a1.583 1.583 0 01.583 2.158c-.758 1.309-.142 2.375 1.367 2.375.866 0 1.583.709 1.583 1.584v1.466c0 .867-.708 1.584-1.583 1.584-1.509 0-2.125 1.066-1.367 2.375a1.58 1.58 0 01-.583 2.158l-1.442.825c-.658.392-1.508.158-1.9-.5l-.092-.158c-.75-1.309-1.983-1.309-2.741 0l-.092.158c-.392.658-1.242.892-1.9.5l-1.442-.825a1.582 1.582 0 01-.583-2.158c.758-1.309.142-2.375-1.367-2.375a1.588 1.588 0 01-1.583-1.584z","stroke":"#202A21","stroke-width":"1.25","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    